"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var MultiImagePickerThumbs = styled_components_1.default.aside(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 16px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 16px;\n"])));
exports.default = MultiImagePickerThumbs;
var templateObject_1;
//# sourceMappingURL=index.js.map